(function ($, Promise) {

		// Setup the prototype inheritance
		extend(BaseGameLYVLC, SkillGames);

		// Constructor
		function SkillGames() {

			// Super constructor
			BaseGameLYVLC.call(this, "data/skill-games.json");
			this.screensaverDelay = 20;

			this.canvas = false;
			this.games = [];
			this.currentlySelectedInMenu = 0;
			this.feedbackEnabled = false;
			this.timeCanvasCtx = $("#timer-canvas")[0].getContext("2d");

			this.instructionsSwipers = [];
		}

		SkillGames.prototype.buildContent = function () {
			return new Promise($.proxy(function (resolve, reject) {

				// Define all games
				var gamesNames = ["game1", "game2", "game3"];

				// Create instructions slides
				var $model = $("#game-intro-model").attr("id", "").remove();
				$(gamesNames).each($.proxy(function (i, game) {
					var $el = $model.clone();
					var $slideModel = $el.find("#game-intro-slide-model").attr("id", "").remove();
					$el.addClass("specific-to-" + game);

					$(this.data.games[game].instructions).each($.proxy(function (i2, instruction) {
						var $slideEl = $slideModel.clone();
						var isFirst = (i2 == 0);
						var isLast = (i2 == this.data.games[game].instructions.length - 1);

						// Set content and attributes
						$slideEl.find(".description .en").html(instruction.text.en);
						$slideEl.find(".description .fr").html(instruction.text.fr);
						$slideEl.find(".start-game-trigger").attr("data-action-arg", game);

						if (instruction.video !== false) {
							$slideEl.find("video.en source").attr("src", instruction.video.en);
							$slideEl.find("video.fr source").attr("src", instruction.video.fr);
						} else {
							$slideEl.find(".group-left").remove();
							$slideEl.find(".group-right").removeClass("group-right").addClass("group-center");
						}

						if (isFirst) {
							$slideEl.find(".button-prev").remove();
						}

						if (!isLast) {
							$slideEl.find(".button-enter").remove();
						} else {
							$slideEl.find(".button-next").remove();
						}

						$el.find(".swiper-wrapper").append($slideEl);

					}, this));

					$("#screen-3").append($el);

				}, this));

				// Create instructions sliders
				$("#screen-3 .swiper-container").each($.proxy(function (i, n) {
					var swiper = new Swiper(n, {
						speed: 400,
						spaceBetween: 100,
						pagination: {
							el: $('.swiper-pagination', n),
							type: 'bullets',
						},
						// effect: "fade",
					});

					// Handle instructions videos play/pause
					swiper.on("slideChangeTransitionStart", $.proxy(function () {
						this.stopInstructionVideos(swiper);
					}, this));
					swiper.on("touchStart", $.proxy(function () {
						this.stopInstructionVideos(swiper);
					}, this));
					swiper.on("transitionEnd", $.proxy(function () {
						this.startInstructionVideo(swiper, swiper.activeIndex);
					}, this));

					this.instructionsSwipers.push(swiper);

					$(".button-prev", n).on(this.touchEvent, $.proxy(function () {
						swiper.slidePrev();
					}, this));

					$(".button-next, .button-enter", n).on(this.touchEvent, $.proxy(function () {
						if (swiper.activeIndex >= (swiper.slides.length - 1)) {
							this.startGame("game" + (this.currentGame + 1));
						} else {
							swiper.slideNext();
						}
					}, this));

				}, this));

				// Init game canvas (PIXI)
				this.canvas = $("#game-canvas").get(0);
				this.renderer = PIXI.Renderer.create({
					width: 1920,
					height: 1080,
					backgroundColor: 0xFFFFFF,
					view: this.canvas,
					resolution: 1,
					antialias: true,
					// resolution: window.devicePixelRatio || 1,
				});

				this.canvas.addEventListener("webglcontextlost", function(event) {
					this.restartApp();
				}.bind(this), false);

				this.games[0] = new SkillGamesGame1(this.renderer, this);
				this.games[1] = new SkillGamesGame2(this.renderer, this);
				this.games[2] = new SkillGamesGame3(this.renderer, this);

				// Preload audio
				// var allAudioFiles = this.findAllAudioFiles(this.data);
				// this.audio.preload(allAudioFiles)

				resolve();

			}, this));
		}

		// To be overriden in child games
		SkillGames.prototype.initGame = function () {
			console.log("init game")

			// Go to first screen
			if (inElectron()) {
				this.initScreenSaver();
				this.goToScreen(1);
			} else {
				$(document).one(this.touchEvent, $.proxy(this.initScreenSaver, this));
				this.goToScreen("first-click-interact");
			}

			// this.goToScreen(1);

			// this.goToScreen(2);

			// this.initScreenSaver();
			// this.goToScreen("onstart-identification");

			// // this.goToScreen(2);
			// this.showFeedback("completed")

			// this.selectGame("game2")
			// this.goToScreen(3);

			// this.selectGame("game3")
			// this.goToScreen(3);

			// Start specific game
			// var gameId = "game3"
			// $(".specific-to-game1").toggle(gameId == "game1");
			// $(".specific-to-game2").toggle(gameId == "game2");
			// $(".specific-to-game3").toggle(gameId == "game3");
			// this.startGame(gameId);
			// this.goToScreen(4);

			// this.showFeedback("game3-try-again")
			// this.showFeedback("game3-feedback")
			// this.games[2].stop();
			// this.games[2].completeGame();
			// this.games[2].firstFailGame();
			// this.games[2].secondFailGame();
			// this.games[2].successLevel();

			// $("#game-feedback-completed .level-reached").html((3));
			// $("#game-trigger-1").addClass("completed")
			// this.showFeedback("completed");

			// Close still there on touch screen
			$(document).on(this.touchEvent, $.proxy(function () {
				this.resetTimer();
				if (this.stillThereTimeout != false) {
					this.closeStillThereModal();
					return;
				}
			}, this));

		};

		// To be overriden in child games
		SkillGames.prototype.initScreen = function (screenId) {

			// Super constructor
			if (BaseGameLYVLC.prototype.initScreen.call(this, screenId) == false) {
				return false;
			}

			switch (screenId) {
				case 1:
					this.reset();
					break;
				case 2:
					this.currentlySelectedInMenu = 0;
					this.closeFeedback();
					this.stopAllGames();
					break;
				case 3:
					this.instructionsSwipers[this.currentGame].slideTo(0, 0);
					this.startInstructionVideo(this.instructionsSwipers[this.currentGame], 0);
					break;
				case 4:
					this.stopAllInstructionVideos();
					break;
				case 5:
					break;
			}
		}

		// To be overriden in child games
		SkillGames.prototype.onMessage = function (e) {
			var message = e.message;
			console.log("message received : ", message);

			// Reset still there interval
			this.resetTimer();

			if (this.lockScreen) {
				return;
			}

			if (this.stillThereTimeout != false) {
				this.closeStillThereModal();
				return;
			}

			// Global buttons
			switch (this.currentScreen) {
				case 1:
					if (message == this.buttons["english"]) {
						// English button
						this.requestedLanguage = "en";
						this.goToScreen(2);
					} else if (message == this.buttons["french"]) {
						// French button
						this.requestedLanguage = "fr";
						this.goToScreen(2);
					} else if (message == this.buttons["home"]) {
						// Home button
					}
					break;
				default:
					if (message == this.buttons["english"]) {
						// English button
						this.i18n.setWithFlip("en");
						this.initScreen(this.currentScreen);
					} else if (message == this.buttons["french"]) {
						// French button
						this.i18n.setWithFlip("fr");
						this.initScreen(this.currentScreen);
					} else if (message == this.buttons["home"]) {
						// Home button
						this.goToScreen(1);
					}
					break;
			}

			// Left, right and select butttons
			switch (this.currentScreen) {
				case 1:
					break;
				case 2:
					var availableGames = this.getAvailableGames();
					if (message == this.buttons["left"]) {
						// LEFT button
						this.currentlySelectedInMenu = (this.currentlySelectedInMenu - 1 >= 0) ? (this.currentlySelectedInMenu - 1) : (availableGames.length - 1);
						$(".game-trigger").removeClass("selected");
						$("#game-trigger-" + availableGames[this.currentlySelectedInMenu]).addClass("selected");
					} else if (message == this.buttons["right"]) {
						// Right button
						this.currentlySelectedInMenu = (this.currentlySelectedInMenu + 1) % availableGames.length;
						$(".game-trigger").removeClass("selected");
						$("#game-trigger-" + availableGames[this.currentlySelectedInMenu]).addClass("selected");
					} else if (message == this.buttons["select"]) {
						// Select button
						$(".game-trigger").removeClass("selected");
						$("#game-trigger-" + availableGames[this.currentlySelectedInMenu]).addClass("selected");
						this.selectGame("game" + (this.currentlySelectedInMenu + 1));
					}
					break;
				case 3:
					var swiper = $("#screen-3 .specific-to-game" + (this.currentGame + 1) + " .swiper-container").get(0).swiper;
					if (message == this.buttons["select"] || message == this.buttons["right"]) {
						// SELECT or RIGHT button
						if (swiper.activeIndex >= (swiper.slides.length - 1)) {
							this.startGame("game" + (this.currentGame + 1));
						} else {
							swiper.slideNext();
						}

					} else if (message == this.buttons["left"]) {
						// LEFT button
						swiper.slidePrev();
					}
					break;
				// case 4:
				// 	var isLocked = $("#screen-4 #word-wrapper").hasClass("lock");
				// 	if (!isLocked && message == this.buttons["left"]) {
				// 		// Previous button
				// 		this.selectPreviousLetter();
				// 	}
				// 	if (!isLocked && message == this.buttons["select"]) {
				// 		// Select button
				// 		if ($("#screen-4 #word-wrapper .letter.selected").hasClass("last")) {
				// 			this.validateWord();
				// 		} else {
				// 			this.selectNextLetter();
				// 		}
				// 	}
				// 	if (!isLocked && message == this.buttons["right"]) {
				// 		// Next button
				// 		this.selectNextLetter();
				// 	}
				// 	if (!isLocked && message.startsWith("SLIDE_")) {
				// 		// Slider
				// 		this.setLetter(this.currentlySelectedSliderLetter);
				// 	}
				// 	break;
				case 4:
					if (this.feedbackEnabled && message == this.buttons["select"] || message == this.buttons["right"]) {
						// SELECT or RIGHT button
						var hasAdditionalGames = this.hasAvailableGames();
						if (hasAdditionalGames) {
							this.goToScreen(2);
						} else {
							this.goToScreen(1);
						}
					}
					break;
			}
		}

		SkillGames.prototype.selectGame = function (gameId) {

			if (gameId == "game1") {
				this.currentGame = 0;
			} else if (gameId == "game2") {
				this.currentGame = 1;
			} else if (gameId == "game3") {
				this.currentGame = 2;
			}

			$("#backgrounds").addClass("shown");

			$(".specific-to-game1").toggle(gameId == "game1");
			$(".specific-to-game2").toggle(gameId == "game2");
			$(".specific-to-game3").toggle(gameId == "game3");
			this.goToScreen(3);
		}

		SkillGames.prototype.startGame = function (gameId) {

			if (gameId == "game1") {
				this.currentGame = 0;
			} else if (gameId == "game2") {
				this.currentGame = 1;
			} else if (gameId == "game3") {
				this.currentGame = 2;
			}

			for (var i = 0; i < this.games.length; i++) {
				this.games[i].reset();
			}

			this.games[this.currentGame].start();

			this.goToScreen(4);
		}

		SkillGames.prototype.drawTime = function (norm) {
			var centerX = 27;
			var centerY = 37;
			var radius = 18;
			var path = new Path2D('M54.284,19.011 L50.215,23.031 C50.215,23.031 50.215,23.031 50.215,23.031 C50.897,24.132 51.494,25.285 52.009,26.485 C53.397,29.727 54.101,33.171 54.101,36.718 C54.101,40.266 53.397,43.708 52.009,46.951 C50.903,49.534 49.403,51.900 47.540,54.004 C47.146,54.451 46.736,54.884 46.309,55.305 C44.802,56.793 43.143,58.085 41.350,59.166 C40.235,59.839 39.069,60.431 37.854,60.938 C35.560,61.896 33.167,62.525 30.706,62.816 C29.649,62.942 28.578,63.004 27.498,63.004 C26.418,63.004 25.349,62.942 24.291,62.816 C21.832,62.525 19.438,61.898 17.143,60.938 C15.929,60.431 14.762,59.839 13.647,59.167 C11.853,58.085 10.195,56.794 8.688,55.305 C8.261,54.884 7.851,54.451 7.457,54.004 C5.594,51.900 4.094,49.534 2.987,46.951 C1.601,43.708 0.896,40.266 0.896,36.718 C0.896,33.171 1.601,29.727 2.987,26.485 C3.502,25.285 4.101,24.132 4.782,23.031 C4.782,23.031 4.782,23.031 4.782,23.031 L4.782,23.031 L0.713,19.011 C0.006,18.312 0.006,17.177 0.713,16.478 L3.857,13.372 C4.565,12.673 5.712,12.673 6.420,13.372 L10.004,16.914 L10.004,16.914 C10.004,16.914 10.004,16.914 10.004,16.914 C12.134,15.073 14.529,13.591 17.143,12.498 C19.438,11.539 21.832,10.911 24.291,10.619 C24.291,10.619 24.291,10.619 24.291,10.619 L24.291,7.119 L30.706,7.119 L30.706,10.620 C33.167,10.911 35.560,11.539 37.854,12.498 C40.469,13.591 42.863,15.073 44.992,16.914 L48.577,13.372 C49.285,12.673 50.432,12.673 51.140,13.372 L54.284,16.478 C54.991,17.177 54.991,18.312 54.284,19.011 ZM46.376,26.826 C46.376,26.825 46.376,26.825 46.376,26.825 L46.376,26.825 C46.065,26.249 45.726,25.691 45.365,25.148 C44.228,23.440 42.851,21.902 41.275,20.587 C38.327,18.122 34.696,16.434 30.706,15.838 L30.706,15.838 C30.376,15.789 30.038,15.760 29.703,15.726 C28.976,15.651 28.244,15.600 27.498,15.600 C26.774,15.600 26.062,15.649 25.356,15.718 C25.000,15.754 24.642,15.785 24.291,15.837 L24.291,15.837 C24.291,15.837 24.291,15.837 24.291,15.837 C20.302,16.433 16.670,18.122 13.722,20.587 C13.277,20.959 12.855,21.356 12.442,21.762 C10.930,23.249 9.632,24.949 8.621,26.826 L8.621,26.825 C8.621,26.825 8.621,26.826 8.621,26.826 C7.030,29.778 6.128,33.146 6.128,36.718 C6.128,41.901 8.027,46.654 11.174,50.332 C12.928,52.382 15.070,54.101 17.487,55.371 C19.574,56.470 21.867,57.236 24.291,57.599 C25.337,57.755 26.408,57.835 27.498,57.835 C28.588,57.835 29.660,57.755 30.706,57.598 C33.131,57.236 35.423,56.470 37.510,55.371 C39.927,54.101 42.069,52.382 43.823,50.332 C46.970,46.654 48.869,41.901 48.869,36.718 C48.869,33.146 47.967,29.778 46.376,26.826 ZM19.356,1.361 C19.356,0.606 19.976,-0.007 20.740,-0.007 L34.257,-0.007 C35.020,-0.007 35.640,0.606 35.640,1.361 L35.640,7.119 L19.356,7.119 L19.356,1.361 Z');

			this.timeCanvasCtx.clearRect(0, 0, 55, 63);
			this.timeCanvasCtx.fillStyle = "#000000";
			this.timeCanvasCtx.fill(path);
			this.timeCanvasCtx.fillStyle = "#9D9FA2";
			this.timeCanvasCtx.strokeStyle = "none";
			this.timeCanvasCtx.beginPath();
			this.timeCanvasCtx.moveTo(centerX, centerY);
			this.timeCanvasCtx.arc(centerX, centerY, radius, (Math.PI * 1.5) - norm * (Math.PI * 2), (Math.PI * 1.5));
			this.timeCanvasCtx.closePath();
			this.timeCanvasCtx.fill();
		}

		SkillGames.prototype.showFeedback = function (feedbackId) {

			if (this.feedbackEnabled) {
				return;
			}

			this.feedbackEnabled = true;
			$("#game-feedback").addClass("active");

			var hasAdditionalGames = this.hasAvailableGames();
			$("#game-feedback-" + feedbackId).toggleClass("has-more-games", hasAdditionalGames);
			$("#game-feedback-" + feedbackId).toggleClass("no-more-games", !hasAdditionalGames);

			// Animate in
			var tl = new TimelineMax();
			tl.fromTo("#game-feedback-overlay", 0.3, {
				autoAlpha: 0,
				ease: Sine.easeInOut
			}, {
				autoAlpha: 1,
				ease: Sine.easeInOut
			});
			tl.fromTo("#game-feedback-" + feedbackId, 0.3, {
				autoAlpha: 0,
				y: 100,
				ease: Sine.easeInOut
			}, {
				autoAlpha: 1,
				y: 0,
				ease: Sine.easeInOut
			});
		}

		SkillGames.prototype.closeFeedback = function () {

			if (!this.feedbackEnabled) {
				return;
			}

			var tl = new TimelineMax();
			tl.to(".popup", 0.3, {
				autoAlpha: 0,
				y: 100,
				ease: Sine.easeInOut
			});
			tl.to("#game-feedback-overlay", 0.3, {
				autoAlpha: 0,
				ease: Sine.easeInOut
			});
			tl.addCallback(function () {
				this.feedbackEnabled = false;
				$("#game-feedback").removeClass("active");
			}, "+=0.0", [], this);
		}

		SkillGames.prototype.tryAgain = function () {
			if (this.games[this.currentGame].tryAgain) {
				this.games[this.currentGame].tryAgain();
			}
		}

		SkillGames.prototype.nextLevel = function () {
			this.games[this.currentGame].nextLevel();
		}

		SkillGames.prototype.goToScreenSaver = function () {

			// Super constructor
			if (BaseGameLYVLC.prototype.goToScreenSaver.call(this) == false) {
				return false;
			}
		}

		SkillGames.prototype.getAvailableGames = function () {
			var availableGames = [];

			if (!$("#game-trigger-1").hasClass("completed") && !$("#game-trigger-1").hasClass("failed")) {
				availableGames.push(1);
			}
			if (!$("#game-trigger-2").hasClass("completed") && !$("#game-trigger-2").hasClass("failed")) {
				availableGames.push(2);
			}
			if (!$("#game-trigger-3").hasClass("completed") && !$("#game-trigger-3").hasClass("failed")) {
				availableGames.push(3);
			}
			return availableGames;
		}

		SkillGames.prototype.hasAvailableGames = function () {
			return (this.getAvailableGames().length > 0);
		}

		SkillGames.prototype.startInstructionVideo = function (swiper, slideIndex) {
			var slides = $(swiper.el).find(".swiper-slide");
			slides.each(function (i, n) {
				$(n).find("video").each(function (i2, n2) {
					if (i == slideIndex) {
						n2.play();
					} else {
						n2.currentTime = 0;
						n2.pause();
					}
				});
			});
		}

		SkillGames.prototype.stopInstructionVideos = function (swiper) {
			var slides = $(swiper.el).find(".swiper-slide");
			slides.each(function (i, n) {
				$(n).find("video").each(function (i2, n2) {
					n2.pause();
				});
			});
		}

		SkillGames.prototype.stopAllInstructionVideos = function () {
			var videos = $(".instructions-wrapper .swiper-slide video");
			videos.each(function (i, n) {
				n.pause();
			});
		}

		SkillGames.prototype.stopAllGames = function () {
			// Stop all subgames
			for (var i = 0; i < this.games.length; i++) {
				this.games[i].stop();
				this.games[i].reset();
			}

			$("#backgrounds").removeClass("shown");
		}

		SkillGames.prototype.reset = function (screenId) {

			console.log("main reset()")

			// Super
			if (BaseGameLYVLC.prototype.reset.call(this, screenId) == false) {
				return false;
			}

			this.currentlySelectedInMenu = 0;

			// Stop all subgames
			this.stopAllGames();

			this.stopAllInstructionVideos();

			// Reset sliders
			for (var i = 0; i < this.instructionsSwipers.length; i++) {
				this.instructionsSwipers[i].slideTo(0, 0);
			}

			this.closeFeedback();

			$('.swiper-container').each(function (i, n) {
				n.swiper.slideTo(0, 0)
			});

			$("#game-trigger-1").removeClass("completed failed selected");
			$("#game-trigger-2").removeClass("completed failed selected");
			$("#game-trigger-3").removeClass("completed failed selected");

			$(".specific-to-game1").toggle(false);
			$(".specific-to-game2").toggle(false);
			$(".specific-to-game3").toggle(false);
		}

		// Expose SkillGames
		window.SkillGames = SkillGames;
	}
)
(jQuery, Promise);
